import React, {useContext} from 'react';
import {AboutMusicVideoRender} from './AboutMusicVideoRender';
import {NavigateFunction, Params, useNavigate, useParams} from 'react-router-dom';
import {MutationTuple, QueryResult, useMutation, useQuery} from '@apollo/client';
import {query} from 'actions/queries';
import {mutation} from 'actions/mutations';
import {FormField, FormHook} from 'hooks/useForm/interfaces';
import {useForm} from 'hooks/useForm/useForm';
import {CulturalAlert, Item, ItemApi} from 'interfaces';
import {UserContext, userContextInterface} from 'context/userContext';
import { sortListBy } from 'tools/globalActions';

export const AboutMusicVideo = ():JSX.Element => {

	const navigate:NavigateFunction=useNavigate();
	const {id}:Params = useParams();
	const {user}:userContextInterface=useContext(UserContext);

	// optionsData
	const {data:stateData}:QueryResult=useQuery(query('stateFindMany'));
	// alert
	const {data:alertsData}:QueryResult =useQuery(query('culturalAlertFindMany'),
		{variables:{
			filter:{
				_id:id,
				user:user._id
			}
		}});
	const alertData:CulturalAlert= alertsData?.culturalAlertFindMany[0]||{};

	const [updateAlert]:MutationTuple<any, any> =useMutation(mutation('culturalAlertUpdateOne'));
	const setMusicEventInfo=async(data:any):Promise<void> =>{
		console.log('submit',{data});
		const feeRange:any={
			min:data.feeRange[0],
			max:data.feeRange[1]
		};
		data.videoShootTime=parseFloat(data.videoShootTime);
		data.feeRange=feeRange;
		await updateAlert({
			variables:{
				_id:id,
				record:{...data}
			}
		});
		navigate(`/company/alerts/${id}/edit/additional-info`);
	};

	const  formFields:FormField[]=[
		{name:'videoShootDate',	default:alertData.videoShootDate},
		{name:'videoShootTime',	default:alertData.videoShootTime},
		{name:'endDate',		default:alertData.endDate},
		{name:'eventLocation',	default:alertData.eventLocation},
		{name:'city',			default:alertData.city},
		{name:'state',			default:alertData.state},
		{name:'feeRange',		default:[alertData.feeRange?.min || 215e3,alertData.feeRange?.max || 650e3]}
	];
	const {loading,errors,...rest}:FormHook=useForm(formFields,setMusicEventInfo);
	const states:Item[]=stateData?.stateFindMany.map((e:ItemApi):Item=> ({id:e.label,label:e.label}) )||[];


	return <AboutMusicVideoRender
		submitLoading={loading}
		errors={errors}
		onSubmit={rest.handleSubmitForm}
		options={{
			states:sortListBy(states,'label')
		}}
		{...rest}
	/>;
};